import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { ErrorMessages } from "src/app/shared/common/errormessages";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { VaultObjectgroupService } from "../vaultobject-popup-screen/vault-objectgroup.service";
import { VaultobjectPopupScreenComponent } from "../vaultobject-popup-screen/vaultobject-popup-screen.component";
import { VaultobjectgroupchildComponent } from "../vaultobjectgroupchild/vaultobjectgroupchild.component";
import { constants } from "src/app/shared/common/contants";
import { DatasetgroupPopupScreenComponent } from "../datasetgroup-popup-screen/datasetgroup-popup-screen.component";
import { DatasetGroupCHildCOmponentComponent } from "../dataset-group-child-component/dataset-group-child-component.component";
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';

@Component({
    selector: "app-datasetgroup",
    templateUrl: "./datasetgroup.component.html",
    styleUrls: ["./datasetgroup.component.scss"],
    standalone: false
})
export class DatasetgroupComponent implements OnInit {
  columnDefs;
  components: any;
  rowSelection;
  paginationPageSize;
  backgroundColorScreen = "";
  buttonColor = "";
  defaultColDef;
  rowClassRules;
  rowbindingdata;
  lastpage;
  currentpage;
  nextpage;
  nextpageplusone;
  totalpages;
  paginationNumberFormatter;
  ngModelObjectDivision = [];
  ngModelObject = [];
  tableName = "";
  dynamicData = [];
  retrieveObject: any = [];
  grid;
  objectData: any = [];
  datasetobjectattributes: [];
  pagesiz;
  pagesize;
  rowdata: any = [];
  editmode: boolean = false;
  gridApi;
  pageSize;
  reportCreationData: any = [];
  headerNameHtml = "";
  validation_messages;
  deleteData: any = [];
  groupName: any;
  objectGroupData: any = [];
  status: any;
  value;
  buttonIdList: any =[];
  // reportCreationData={"description":"", "groupname":"",objectid: []}

  constructor(
    private userRoutingModule:UserRoutingModule,
    private reportLinkService:ReportlinksserviceService,
    private localStorageSettings: LocalStorageSettingsService,
    private constants: constants,
    private dialog: MatDialog,
    private vaultObjectService: VaultObjectgroupService,
    private commonService: CommonService,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private msg: ErrorMessages
  ) {
    this.components = {
      buttonRenderer: Actionbutton,
    };
    this.validation_messages = this.msg.reportConfiguration;
  }

  ngOnInit() {
    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

    this.columnDefs = [
      {
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: {
          values:this.buttonIdList,
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        },
        width: 150,
      },
      {
        headerName: "Group Id",
        headerTooltip: "Group Id",
        tooltipValueGetter: (params) => "Group Id : " + params.value,
        field: "datasetGroupId",
        filter: "agTextColumnFilter",
        width: 110,
        suppressSizeToFit: true,
      },
      {
        headerName: "Group Name",
        headerTooltip: "Group Name",
        tooltipValueGetter: (params) => "Group Name : " + params.value,
        field: "datasetGroupName",
        filter: "agTextColumnFilter",
        width: 250,
        suppressSizeToFit: true,
      },
      {
        headerName: "Group Description",
        headerTooltip: "Group Description",
        tooltipValueGetter: (params) => "Group Description : " + params.value,
        field: "description",
        filter: "agTextColumnFilter",
        width: 300,
      },
      {
        headerName: "Created Date and Time",
        headerTooltip: "Created Date and Time",
        tooltipValueGetter: (params) => "Created Date and Time : " + params.value,
        field: "createdDateTime",
        filter: "agTextColumnFilter",
        width: 250,
      },
      {
        headerName: "Status",
        headerTooltip: "Status",
        tooltipValueGetter: (params) => "Status : " + params.value,
        field: "status",
        filter: "agTextColumnFilter",
        width: 150,
         cellStyle: (params) => {
      if (params.value === 'Yes') {
        return { 
          color: 'green', 
         
          'text-align': 'center'
        };
      } else if (params.value === 'No') {
        return { 
          color: 'red', 
         
          'text-align': 'center'
        };
      }
      return null;
    }
  },

    ];
    // if the record has status==no , row color will change
    this.rowClassRules = {
      sick: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
    };
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen =
      this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();

      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1;

      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1;

      this.nextpageplusone =
        this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalpages = this.gridApi.paginationGetTotalPages();
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridApi.paginationGoToPage(searchValue - 1);
  }

  
      // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pagesize
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
  }
  

  // below function is for going to next page
  async onBtNext() {
    /*this.recordsStart = this.recordsStart + 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

    console.log(this.retrieveObject);

    if (this.retrieveObject.length == 0) {

      this.recordsStart = this.recordsStart - 100;

    }

    else {

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridApi.paginationGoToNextPage();
  }

  // below function for going to previous page
  async onBtPrevious() {
    /*if (this.recordsStart > 0) {

      this.recordsStart = this.recordsStart - 100;

      this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

      console.log(this.retrieveObject);

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridApi.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridApi.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridApi.paginationGoToLastPage();
  }
  //pagination code ends

  openSaveForm() {
    let width = "70%";
    let dialogRef = this.dialog.open(DatasetgroupPopupScreenComponent, {
      maxWidth: "100vw",
      height: "90%",
      width: width,
      data: {},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);

      this.reportCreationData = result;

      this.vaultObjectService.retrieveobjectgroup();
    });
  }
  async onGridReady(params) {
    // let tableName="vaultobjectgroup";
    // let response = await  this.commonService.retrieveRecordService(tableName);
    // console.log(response.data);
    this.rowbindingdata = params;
    this.vaultObjectService.retrieveDatasetGroup().subscribe((res) => {
      console.log(res);
      this.objectData = res;
      console.log("Successfully");
      this.grid = params;
      console.log(params);
      this.gridApi = params.api;
      console.log(params.api);
      this.grid.api.setGridOption('rowData', this.objectData);
    });
    this.spinner.stop();
  }

  EditIcon(groupName) {
    console.log(groupName);
    this.status = groupName.rowData.status;
    if (this.status == "Yes") {
      let width = "70%";
      this.dialog.open(DatasetGroupCHildCOmponentComponent, {
        maxWidth: "100vw",
        height: "90%",
        width: width,
        data: { data: groupName },
        disableClose: true,
      });
    } else {
      this.snackbar.open(
        "Cannot edit object group which is already deleted.",
        "OK",
        {
          duration: 8000,
        }
      );
    }
    console.log(groupName.rowData.objectgroupname);
    this.groupName = groupName.rowData.objectgroupname;
    this.vaultObjectService
      .retrieveobjects(this.groupName)
      .subscribe((result) => {
        console.log(result);
        this.objectGroupData = result;
        this.objectGroupData.api.setGridOption('rowData', result);
      });
  }

 /*
 * Modified by Sujeet Sharma
 * @Date 23/10/2025
 *  Enhanced deleteIcon() method for Object Group soft delete functionality.
 *  Performs soft delete by updating record status to 'No'.
 */
  deleteIcon(event) {
    console.log("inside delete -->> ")
    console.log(event.rowData)
    this.status = event.rowData.status;
    if (this.status == "Yes") {
      if (confirm("Are you sure you want to delete the Dataset group?")) {
        console.log(event.rowData.objectgroupname);
        this.groupName = event.rowData.objectgroupname;
        this.vaultObjectService
          .deleteDatasetGroup(event.rowData.datasetGroupId)
          .subscribe((res) => {
            this.spinner.start();
           
            if (res.error == true) {
              this.snackbar.open(res.statusMessage, "OK", {
                duration: 5000,
              });
            } else {
              this.snackbar.open(res.statusMessage, "OK", {
                duration: 5000,
              });
             
                        this.vaultObjectService.retrieveDatasetGroup().subscribe((updatedRes) => {
                            this.objectData = updatedRes;
                            this.grid.api.setGridOption('rowData', this.objectData);
                        });
                    
            }
            
            this.spinner.stop();
          });
      }
    } else {
      this.snackbar.open("This Dataset Group is already deleted.", "OK", {
        duration: 5000,
      });
    }
  }

   //excel export function
   onBtExport() {
    this.rowbindingdata.api.exportDataAsCsv();
  }

}
